import { ActionTree } from 'vuex';
import {
  EDirectoryAction,
  EDirectoryMutation,
  state as defaultState,
} from '@/content-library/directories/store/directory.constants';
import { IDirectoryState } from '@/content-library/directories/store/directory.types';
import { RootState } from '@/store/store';
import { DirectoryService } from '@/api/directories/services/directory.service';
import { IDirectory } from '@/api/directories/types/directory';
import { IBreadcrumb } from '@/breadcrumbs/types/Breadcrumb';

export const actions: ActionTree<IDirectoryState, RootState> = {
  async [EDirectoryAction.Load]({ dispatch, commit }, path: string) {
    commit(EDirectoryMutation.SetLoading, true);
    commit(EDirectoryMutation.SetLoaded, false);
    try {
      const directories: IDirectory[] = await DirectoryService.loadDirectories(path);
      dispatch(EDirectoryAction.LoadSuccess, directories);
    } catch {
      dispatch(EDirectoryAction.LoadFailed);
    }
  },
  [EDirectoryAction.LoadSuccess]({ commit }, directories: IDirectory[]) {
    commit(EDirectoryMutation.SetDirectories, directories);
    commit(EDirectoryMutation.SetLoading, false);
    commit(EDirectoryMutation.SetLoaded, true);
  },
  [EDirectoryAction.LoadFailed]({ commit }) {
    commit(EDirectoryMutation.SetLoading, false);
    commit(EDirectoryMutation.SetLoaded, false);
  },
  [EDirectoryAction.AddDirectory]({ commit, state }, directory: IDirectory) {
    commit(EDirectoryMutation.SetDirectories, [...state.directories, directory]);
  },
  [EDirectoryAction.RemoveDirectory]({ commit, state }, id: string) {
    const stateDirectories: IDirectory[] = state.directories.filter(
      (directory: IDirectory) => directory.id !== id
    );
    commit(EDirectoryMutation.SetDirectories, stateDirectories);
  },
  [EDirectoryAction.UpdateDirectory]({ commit, state }, directory: IDirectory) {
    const updatedDirectories: IDirectory[] = state.directories.map((stateDirectory: IDirectory) =>
      stateDirectory.id === directory.id ? directory : stateDirectory
    );
    commit(EDirectoryMutation.SetDirectories, updatedDirectories);
  },
  [EDirectoryAction.UpdateBreadcrumbs]({ commit }, breadcrumbs: string[]) {
    const newCrumbs: IBreadcrumb[] = breadcrumbs.map(
      (crumb: string, index: number): IBreadcrumb => {
        return {
          label: index === 0 ? '' : crumb,
          icon: index === 0 ? 'folder' : '',
        };
      }
    );
    commit(EDirectoryMutation.SetBreadcrumbs, newCrumbs);
  },
  [EDirectoryAction.ResetState]({ commit }) {
    commit(EDirectoryMutation.SetState, defaultState);
  },
};
